import { render, staticRenderFns } from "./bettingTable.vue?vue&type=template&id=3524ca77&"
import script from "./bettingTable.vue?vue&type=script&lang=js&"
export * from "./bettingTable.vue?vue&type=script&lang=js&"
import style0 from "./bettingTable.vue?vue&type=style&index=0&id=3524ca77&prod&lang=css&"
import style1 from "./bettingTable.vue?vue&type=style&index=1&id=3524ca77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports